"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubTopic = void 0;
var lodash_1 = require("lodash");
var graphql_1 = require("../../utils/graphql");
var create_entity_1 = require("../../utils/create-entity");
var sub_topic_details_layout_1 = require("../../components/entities/sub-topic-details-layout");
var entity_outline_number_rank_1 = require("../../utils/entity-outline-number-rank");
var gql = String.raw;
exports.SubTopic = {
  name: 'SubTopic',
  type: 'taxonomy',
  autoRoutes: ['create', 'update', 'list', 'details'],
  groupName: process.env.TAXONOMIES_LABEL || "Challenges & Goals",
  useFollowers: true,
  useModerators: true,
  useConnections: true,
  includeInSearch: true,
  useSiteSlug: true,
  useConversation: true,
  canEmbed: true,
  useSlices: true,
  useSpaces: true,
  sidebar: {
    queryFields: 'outlineNumber',
    sort: function (items) {
      return (0, lodash_1.sortBy)(items, entity_outline_number_rank_1.entityOutlineNumberRank);
    },
    label: function (subTopic) {
      return "".concat(subTopic.outlineNumber ? "".concat(subTopic.outlineNumber, ". ") : '').concat(subTopic.name);
    }
  },
  table: {
    fieldNames: ["name", "outlineNumber", "intro"]
  },
  components: {
    details: sub_topic_details_layout_1.SubTopicDetailsLayout
  },
  export: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      outlineNumber\n      slug\n    "], ["\n      outlineNumber\n      slug\n    "]))),
    sort: function (items) {
      return (0, lodash_1.sortBy)(items, entity_outline_number_rank_1.entityOutlineNumberRank);
    }
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      intro { text }\n      description { id text }\n      openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n      banner { id name image { id url } slug title description { id text } alternateText openGraph { id image { id url } } }\n      topic { id name slug }\n      expertise {\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        person { ...EntityValueFields }\n      }\n      horizons { ...EntityValueFields intro { id text } type { ...EntityValueFields years } description { id text } }\n      events { ...EntityValueFields }\n      sessions { ...EntityValueFields }\n      chapters { ...EntityValueFields }\n      feedEntries { ...EntityValueFields }\n      posts { ...EntityValueFields }\n      pages { ...EntityValueFields }\n      courses { ...EntityValueFields }\n      lessons { ...EntityValueFields }\n      teams { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      locations { ...EntityValueFields }\n      feeds { ...EntityValueFields }\n      videos { url ...EntityValueFields }\n\n    "], ["\n      intro { text }\n      description { id text }\n      openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n      banner { id name image { id url } slug title description { id text } alternateText openGraph { id image { id url } } }\n      topic { id name slug }\n      expertise {\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        person { ...EntityValueFields }\n      }\n      horizons { ...EntityValueFields intro { id text } type { ...EntityValueFields years } description { id text } }\n      events { ...EntityValueFields }\n      sessions { ...EntityValueFields }\n      chapters { ...EntityValueFields }\n      feedEntries { ...EntityValueFields }\n      posts { ...EntityValueFields }\n      pages { ...EntityValueFields }\n      courses { ...EntityValueFields }\n      lessons { ...EntityValueFields }\n      teams { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      locations { ...EntityValueFields }\n      feeds { ...EntityValueFields }\n      videos { url ...EntityValueFields }\n\n    "])))
  },
  banner: {
    queryFields: gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      intro { text }\n      description { id text }\n    "], ["\n      intro { text }\n      description { id text }\n    "]))),
    descriptionField: 'intro',
    showDescription: true
  },
  list: {
    resultsVariant: "grid",
    queryFields: gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      banner { id name image { id url } slug title description { id text } alternateText openGraph { id image { id url } } }\n      openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n      intro { text },\n      description { text plain(truncate: { words: 45 }) },\n    "], ["\n      banner { id name image { id url } slug title description { id text } alternateText openGraph { id image { id url } } }\n      openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n      intro { text },\n      description { text plain(truncate: { words: 45 }) },\n    "])))
  },
  form: {
    modal: {
      fill: true,
      maxWidth: "1200px"
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'horizons'
    }, {
      name: 'data'
    }, {
      name: 'anticipation-scores'
    }, {
      name: 'library'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      banner: {
        type: 'banner'
      },
      outlineNumber: {
        type: 'text',
        maxWidth: '200px'
      },
      intro: {
        type: 'longText'
      },
      description: {
        type: 'longText',
        useCompletions: true
      },
      summary: {
        type: 'longText'
      },
      dataSetId: {
        type: 'text',
        recommended: false,
        description: "Specify an ID to uniquely identify this {{SUB_TOPIC}}. This might be useful to tie this {{SUB_TOPIC}} to values coming from an external API, for example",
        monospace: true
      },
      horizons: {
        type: 'linkedTable',
        entityTypeName: 'Horizon',
        fieldSet: 'horizons'
      },
      feedEntries: {
        type: 'linkedMultiple',
        entityTypeName: 'FeedEntry',
        fieldSet: 'library'
      },
      indicatorResults: {
        type: 'linkedTable',
        entityTypeName: 'IndicatorResult',
        fieldSet: 'data'
      },
      gptName: {
        type: 'text',
        fieldSet: 'admin',
        recommended: false,
        description: 'What name should be used for this {{SUB_TOPIC}} when using it as variable context for GPT queries? If not specified, the regular name will be used'
      },
      icons: {
        type: 'linkedMultiple',
        entityTypeName: 'Icon',
        description: 'Select one or more {{ICONS}} to represent this {{SUB_TOPIC}}'
      },
      banners: {
        type: 'linkedMultiple',
        entityTypeName: 'Banner',
        description: "Does this {{SUB_TOPIC}} have any other {{BANNERS}}? This is useful for assigning {{BANNERS}} for different {{SITES}}"
      },
      backgroundImages: {
        type: 'linkedMultiple',
        entityTypeName: 'ImageAsset',
        label: 'Background Images',
        description: "Does this {{SUB_TOPIC}} have any background images?"
      }
    }),
    reverseFields: {
      expertise: {
        type: 'linkedMultiple',
        label: 'Add {{SUB_TOPIC_EXPERTISE}}',
        entityTypeName: 'SubTopicExpertise',
        source: 'subTopics',
        reverseEntityTypeName: 'Person',
        reverseEntityFieldName: 'subTopicExpertise'
      },
      pages: {
        type: 'linkedMultiple',
        entityTypeName: 'Page',
        source: 'subTopics'
      },
      feedEntries: {
        type: 'linkedMultiple',
        entityTypeName: 'FeedEntry',
        source: 'subTopics'
      },
      videos: {
        type: 'linkedMultiple',
        entityTypeName: 'Video',
        source: 'subTopics'
      },
      posts: {
        type: 'linkedMultiple',
        entityTypeName: 'Post',
        source: 'subTopics'
      },
      events: {
        type: 'linkedMultiple',
        entityTypeName: 'Event',
        source: 'subTopics'
      }
    }
  }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;